<template>
  <button :class="{ active: this.active }" class="stat-btn" @click="this.on_click">
    {{ this.text }}
  </button>
</template>
<script>
export default {
  name: 'TabButton',

  props: {
    text: {
      required: true,
      type: String,
    },

    on_click: {
      required: true,
      type: Function,
    },

    active: {
      required: true,
      type: Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
button.stat-btn {
  @include transparentButton;
  position: relative;
  font-size: 1rem;
  letter-spacing: 1px;

  & + .stat-btn {
    margin-left: 12px;

    @media (max-width: 600px) {
      margin-left: 0;
      margin-top: 12px;
    }
  }

  &:not(.active) {
    color: $gray;
  }

  &.active {
    color: $white;

    .light & {
      color: $main;
    }

    &:before {
      content: '';
      position: absolute;
      height: 2px;
      bottom: -2px;
      background: $blue;
      animation: growWidth 0.45s ease forwards;
    }
  }

  @media (max-width: 600px) {
    order: 1;
  }
}
</style>
